import {MessageDescriptor} from '@lingui/core';
import {t} from '@lingui/macro';

/*
 * Types.
 */

export enum SlaEditorBaseErrorsEnum {
  INVALID_BREACH_CONDITION = 'INVALID_BREACH_CONDITION',
  INVALID_WARNING_CONDITION = 'INVALID_WARNING_CONDITION',
  INVALID_BREACH_ACTION = 'INVALID_BREACH_ACTION',
  INVALID_WARNING_ACTION = 'INVALID_WARNING_ACTION',
  INVALID_BREACH_DELAY = 'INVALID_BREACH_DELAY',
  INVALID_WARNING_DELAY = 'INVALID_WARNING_DELAY',
}

/*
 * Constants.
 */

export const slaEditorBaseErrorLabels: Record<SlaEditorBaseErrorsEnum, MessageDescriptor> = {
  [SlaEditorBaseErrorsEnum.INVALID_BREACH_CONDITION]: t(
    'sla-editor-footer-tooltip-warning-breach-unreplied',
  )`Your breach time condition is invalid`,
  [SlaEditorBaseErrorsEnum.INVALID_WARNING_CONDITION]: t(
    'sla-editor-footer-tooltip-warning-warning-unreplied',
  )`Your warning time condition is invalid`,
  [SlaEditorBaseErrorsEnum.INVALID_BREACH_ACTION]: t(
    'sla-editor-footer-tooltip-warning-breach-action',
  )`One of your breach actions is invalid`,
  [SlaEditorBaseErrorsEnum.INVALID_WARNING_ACTION]: t(
    'sla-editor-footer-tooltip-warning-warning-action',
  )`One of your warning actions is invalid`,
  [SlaEditorBaseErrorsEnum.INVALID_BREACH_DELAY]: t(
    'sla-editor-footer-tooltip-warning-breach-delay',
  )`Your breach delay is invalid`,
  [SlaEditorBaseErrorsEnum.INVALID_WARNING_DELAY]: t(
    'sla-editor-footer-tooltip-warning-delay-warning',
  )`Warning time limit cannot be longer than SLA breach time limit`,
};
